import { NgModule } from '@angular/core';
import { FiChecklist2ReportRecentActivityWidgetContentComponent } from '@fi-shared/checklist/fi-checklist2-report/components/recent-activity-report/recent-activity-widget/recent-activity-widget-content/recent-activity-widget-content.component';
import { FiChecklist2ReportRecentActivityWidget } from '@fi-shared/checklist/fi-checklist2-report/components/recent-activity-report/recent-activity-widget/recent-activity-widget.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { MatButtonModule } from '@angular/material/button';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { FiChecklist2ReportSharedModule } from '@fi-shared/checklist/fi-checklist2-report/components/shared/checklist-report-shared.module';
import { FiTimeAgoPipeModule } from '@fi-shared/fi-time-ago-pipe/fi-time-age.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiItemsListFilterModule } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter.module';
import { FiRecentActivityDialogComponent } from '@fi-shared/checklist/fi-checklist2-report/components/recent-activity-report/recent-activity-widget/recent-activity-dialog/fi-recent-activity-dialog.component';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiEmptyListModule } from '@fi-shared/fi-empty-list/fi-empty-list.module';
import { FiRecentActivityDetailsFilterTableComponent } from '@fi-shared/checklist/fi-checklist2-report/components/recent-activity-report/recent-activity-widget/recent-activity-dialog/recent-activity-details-filter-table/fi-recent-activity-details-filter-table.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';

@NgModule({
    imports: [
        CommonModule,
        FiProfileIconModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatCardModule,
        FiLocalSearch2Module,
        MatButtonModule,
        CdkDragHandle,
        FiChecklist2ReportSharedModule,
        FiTimeAgoPipeModule,
        MatMenuModule,
        FiItemsListFilterModule,
        FiAttachmentsModule,
        FiEmptyListModule,
        FiLoadingModule,
        FiReportWidgetModule,
    ],
    declarations: [
        FiChecklist2ReportRecentActivityWidgetContentComponent,
        FiChecklist2ReportRecentActivityWidget,
        FiRecentActivityDialogComponent,
        FiRecentActivityDetailsFilterTableComponent,
    ],
    exports: [FiChecklist2ReportRecentActivityWidget, FiRecentActivityDialogComponent],
})
export class FiRecentActivityReportModule {}
